import PropTypes from "prop-types";
import React from "react";

export default class ReCaptcha extends React.Component {
  static propTypes = {"recaptchaSiteKey": PropTypes.string.isRequired};

  componentDidMount = () => {
    // This loads the reCAPTCHA script when this component is loaded.
    // The reCAPTCHA challenge would not load when the script was loaded
    // from the Rails view.
    const loadScript = (src) => {
      const tag = document.createElement("script");
      tag.async = false;
      tag.src = src;
      const [body] = document.getElementsByTagName("body");
      body.appendChild(tag);
    };

    loadScript("https://www.google.com/recaptcha/api.js");
  }

  render () {
    const {recaptchaSiteKey} = this.props;

    return (
      <div className="reCaptcha">
        <div
          align="center"
          className="g-recaptcha"
          data-sitekey={recaptchaSiteKey}
        />
      </div>
    );
  }
}
